import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import LocationLink from 'aria-viewer/tour/components/locationLink'
import styleguide from 'aria-viewer/tour/constants/styleGuide'
import { WELCOME_PROMPT_HIDDEN, FROM_VR } from 'aria-viewer/tour/constants/queryConstants'
import {
    SELECTOR_LOCATION_TITLE_INDEX,
    SELECTOR_LOCATION_CLOSE_BUTTON_INDEX,
} from 'aria-viewer/keyboard/constants/tabIndices'
import CloseButton from 'aria-viewer/tour/components/buttons/closeButton'
import { hideDrawer } from 'aria-viewer/drawer/drawerMenuActions'
import { analyticsExperienceSelected } from 'aria-viewer/analytics/analyticActions'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import uriHandler from 'aria-viewer/utils/uriHandler'
import injectSheet from 'react-jss'
import pure from 'recompose/pure'
import compose from 'recompose/compose'
import { setCountDown } from 'aria-viewer/audiomanager/countDownActions'

const styleSheet = {
    toursListContainer: {
        position: 'absolute',
        top: '3.5em',
        left: '0',
        right: '0',
        height: 'calc(100% - 3.5em)',
    },
    tourlink: {
        textAlign: 'center',
        paddingBottom: 12,
        margin: '0 auto',
        position: 'relative',
        width: ({ width }) => width,
        height: ({ height }) => height,
    },
    title: {
        fontWeight: styleguide.fonts.weight.normal,
        position: 'fixed',
        top: 22,
        left: 23,
        fontSize: '1.1em',
        color: styleguide.colors.white,
        textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)',
    },
    closeBtn: {
        position: 'fixed',
        width: '0.7em',
        height: '0.7em',
        right: 23,
        top: 33,
        cursor: 'pointer',
    },
    scrollWrapper: {
        overflowY: 'scroll',
        height: '100%',
        overflowScrolling: 'touch', //overflow scrolling overwrites webkit scrollbar
        // '&::-webkit-scrollbar': { // using webkit scrollbar will disable the mobile accelerator
        // 	width: 4,
        // 	overflow: 'scroll'
        // },
        // '&::-webkit-scrollbar-thumb': {
        // 	background: 'rgba(255, 255, 255, 0.5)',
        // 	borderRadius: 2
        // },
    },
    listWrapper: {
        fontSize: 1,
        margin: 0,
        padding: 0,
    },
}

const ToursListContainer = pure(
    injectSheet(styleSheet)(function ToursListContainer({
        classes,
        title,
        closeButton,
        locationSelectorList,
        tourid,
        locId,
        uniqueId,
        query,
        width,
        height,
        handleClose,
        handleClick,
    }) {
        return (
            <div className={classes.toursListContainer} onClick={handleClose}>
                {title && (
                    <div data-ada-first className={classes.title} tabIndex={SELECTOR_LOCATION_TITLE_INDEX}>
                        {title}
                    </div>
                )}

                {closeButton && (
                    <CloseButton
                        // TODO
                        // Change this to use JSS when button.jsx is modified
                        // to implement jss easier
                        tabIndex={SELECTOR_LOCATION_CLOSE_BUTTON_INDEX}
                        style={styleSheet.closeBtn}
                        onClick={handleClose}
                        labelStyle={{
                            cursor: 'pointer',
                        }}
                    />
                )}

                <div className={classes.scrollWrapper}>
                    <ul className={classes.listWrapper}>
                        {locationSelectorList.map((tour, index) => {
                            var queryWithTourID = {
                                ...query,
                                tourid: tour.tourid,
                            }

                            var queryString = uriHandler.addQueryParams(queryWithTourID) //todo: find a way to add prompthidden dynamically
                            var filterWPHQuery = uriHandler.removeQueryParams([FROM_VR], queryString)
                            var isLinkActiveTour = tour.tourid == tourid && tour.loc_id == locId
                            var owner_unique_id = tour.inst_unique_id || uniqueId
                            var link = `/tour/${owner_unique_id}/${tour.loc_id}${filterWPHQuery}`

                            return (
                                <li className={classes.tourlink} key={`tour_${index}`}>
                                    <LocationLink
                                        selected={isLinkActiveTour}
                                        aspect="fill"
                                        imageSrc={tour.profileImage}
                                        title={tour.name}
                                        alt={tour.name}
                                        to={link}
                                        onClick={handleClick}
                                    />
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    })
)

class ToursList extends PureComponent {
    static defaultProps = {
        closeButton: false,
        title: null,
    }

    constructor(props) {
        super(props)
    }

    handleClick = () => {
        const { analyticsExperienceSelected, hideDrawer, onLinkChange } = this.props

        analyticsExperienceSelected()
        onLinkChange && onLinkChange()
        hideDrawer()
    }

    handleClose = () => {
        const { onClose, hideDrawer } = this.props

        hideDrawer()

        //When the drawer is closed, set the countdown
        this.props.setCountDown(this.props.isAudioButtonVisible && this.props.autoplay)

        onClose && onClose()
    }

    render() {
        const {
            title,
            closeButton,
            locationSelectorList,
            tourid,
            width,
            height,
            location: { inst_unique_id, loc_id },
        } = this.props

        return (
            <ToursListContainer
                title={title}
                closeButton={closeButton}
                locationSelectorList={locationSelectorList}
                tourid={tourid}
                locId={loc_id}
                uniqueId={inst_unique_id}
                query={this.props.query}
                width={width}
                height={height}
                handleClose={this.handleClose}
                handleClick={this.handleClick}
            />
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setCountDown: status => dispatch(setCountDown(status)),
    }
}

export default compose(
    connect(mapSelectorsToProps(['isAudioButtonVisible', 'locationSelectorList', 'location', 'tourid']), {
        hideDrawer,
        analyticsExperienceSelected,
    }),
    connect(
        state => ({
            query: state.get('routing').location.query,
            autoplay: state.getIn(['audioManager', 'autoplay']),
        }),
        mapDispatchToProps
    )
)(ToursList)
